<div ng-controller="escalationConfigController as escalationConfigCtrl" class="modal-view escalation-config-controller">
    <c-auto-form config="escalationConfigCtrl.autoFormConfig"></c-auto-form>
</div>